<layout-page-container>
  <layout-header-container title="Geräte">
    <span (click)="Connection?.start()"
          [class.!text-green-600]="Connection?.state == HubConnectionState.Connected"
          [class.!text-red-600]="Connection?.state == HubConnectionState.Disconnected"
          [class.pointer-events-auto]="Connection?.state == HubConnectionState.Disconnected"
          [class.cursor-pointer]="Connection?.state == HubConnectionState.Disconnected"
          class="place-self-center pl-2 text-yellow-400 pointer-events-none select-none !text-3xl">
      {{ Connection?.state }}
    </span>
  </layout-header-container>

  <!-- The one way in to setting a register up (#469, steps 5 + 7 — one page with a QR tab and a credentials
       tab since #279). It sits above the list, not on a row: it is about a device that does not exist yet, so
       there is no row it could belong to. The two PermissionSets are the two tabs' gates; the page hides a tab
       the session may not open, so the button shows whenever at least one tab would. -->
  @if (PermissionService.CheckPermission(PermissionService.Permissions_DeviceEnrollmentComponent())
       || PermissionService.CheckPermission(PermissionService.Permissions_DeviceCredentialsComponent())) {
    <div class="flex flex-col justify-end gap-3 pb-3 sm:flex-row">
      <a [href]="'/' + onboardingRoute"
         class="inline-flex items-center justify-center rounded-2xl bg-theme-primary-600 px-5 py-2.5 text-sm
                font-semibold text-white shadow-lg shadow-theme-primary-100 transition-all duration-200
                hover:bg-theme-primary-700 hover:shadow-xl active:scale-95">
        Kasse einrichten
      </a>
    </div>
  }

  <div class="flex content-around justify-around pb-3">
    <div class="inline-flex space-x-2">
      <app-switch-medium (isOnChange)="Filter()" [(isOn)]="toggleActive"></app-switch-medium>
      <span class="place-self-center">aktiv</span>
    </div>
    <div class="inline-flex space-x-2">
      <app-switch-medium (isOnChange)="Filter()" [(isOn)]="toggleLocked"></app-switch-medium>
      <span class="place-self-center">gesperrt</span>
    </div>
  </div>

  <layout-page-scrollable>
    <div class="py-6 px-1">
      @if (Devices.length === 0) {
        @if (!initial) {
          <p class="text-sm text-gray-500 italic py-8 border-2 border-dashed border-gray-100 rounded-2xl text-center">
            Keine Geräte gefunden.
          </p>
        } @else {
          <p class="text-sm text-gray-500 animate-pulse py-8 text-center">Lade Geräte…</p>
        }
      } @else {
        <ul role="list" class="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
          @for (device of DevicesFiltered; track device.id) {
            <li class="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 flex flex-col gap-3 transition-all duration-200"
                [class.opacity-60]="!GetSignalRClient(device.id)">

              <!-- Header: status + name + battery + edit -->
              <div class="flex items-center gap-2">
                <span class="h-2.5 w-2.5 rounded-full shrink-0"
                      [class.bg-green-500]="GetSignalRClient(device.id)"
                      [class.bg-gray-300]="!GetSignalRClient(device.id)"
                      [attr.aria-label]="GetSignalRClient(device.id) ? 'Verbunden' : 'Getrennt'"></span>
                <h3 class="text-base font-bold text-gray-900 truncate grow">{{ device.name }}</h3>

                @if (device.deviceInformation) {
                  <div class="flex items-center gap-1.5 shrink-0">
                    @if (device.deviceInformation.batteryState == BatteryState.Charging || device.deviceInformation.batteryState == BatteryState.Full) {
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                           class="bi bi-lightning-charge-fill text-gray-600" viewBox="0 0 16 16">
                        <path d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09z"/>
                      </svg>
                    }
                    <span class="text-xs text-gray-500 tabular-nums">{{ (device.deviceInformation.batteryLevel * 100).toFixed(0) }}%</span>
                    <div class="h-3 w-8 rounded-full bg-gray-200 overflow-hidden">
                      <div class="h-full bg-green-500 rounded-full transition-all"
                           [class.!bg-yellow-500]="device.deviceInformation.batteryLevel <= .35 && device.deviceInformation.batteryLevel > .2"
                           [class.!bg-red-500]="device.deviceInformation.batteryLevel <= .2"
                           [style.width.%]="device.deviceInformation.batteryLevel * 100">
                        @if (device.deviceInformation.batteryState == BatteryState.Charging) {
                          <div class="bg-white/60 h-full battery-charging"
                               [style.animation-duration]="(device.deviceInformation.batteryLevel > .5 ? 5 * device.deviceInformation.batteryLevel : 3) + 's'"></div>
                        }
                      </div>
                    </div>
                  </div>
                }

                @if (PermissionService.CheckPermission(PermissionService.Device_Information_Get())) {
                  <a class="select-none text-gray-400 hover:text-theme-primary-700 cursor-pointer shrink-0 transition-colors"
                     aria-label="Gerät bearbeiten" (click)="redirectToSettings(device.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="bi bi-pen" viewBox="0 0 16 16">
                      <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"/>
                    </svg>
                  </a>
                }
              </div>

              <!-- Details -->
              <dl class="text-sm divide-y divide-gray-50">
                <div class="flex justify-between gap-3 py-1">
                  <dt class="text-gray-500 shrink-0">Geräte-ID</dt>
                  <dd class="text-gray-900 font-medium truncate text-right">{{ device.id }}</dd>
                </div>
                <div class="flex justify-between gap-3 py-1">
                  <dt class="text-gray-500 shrink-0">Seriennummer</dt>
                  <dd class="text-gray-900 font-medium truncate text-right">{{ device.serialNumber || '—' }}</dd>
                </div>
                <div class="flex justify-between gap-3 py-1">
                  <dt class="text-gray-500 shrink-0">Verkaufspunkt</dt>
                  <dd class="text-gray-900 font-medium truncate text-right">{{ device.location?.name || '—' }}</dd>
                </div>
                @if (GetSignalRClient(device.id)) {
                  <div class="flex justify-between gap-3 py-1">
                    <dt class="text-gray-500 shrink-0">Verbindungs-ID</dt>
                    <dd class="text-gray-900 font-medium truncate text-right">{{ GetSignalRClient(device.id)?.id }}</dd>
                  </div>
                }
                <div class="flex justify-between gap-3 py-1">
                  <dt class="text-gray-500 shrink-0">Hersteller</dt>
                  <dd class="text-gray-900 font-medium truncate text-right">{{ device.deviceInformation?.manufacturer ?? 'N/A' }}</dd>
                </div>
                <div class="flex justify-between gap-3 py-1">
                  <dt class="text-gray-500 shrink-0">Modell</dt>
                  <dd class="text-gray-900 font-medium truncate text-right">{{ device.deviceInformation?.model ?? 'N/A' }}</dd>
                </div>
                <div class="flex justify-between gap-3 py-1">
                  <dt class="text-gray-500 shrink-0">Betriebssystem</dt>
                  <dd class="text-gray-900 font-medium truncate text-right">
                    {{ device.deviceInformation?.platform ?? 'N/A' }} {{ device.deviceInformation?.osVersion ?? '' }}
                  </dd>
                </div>

                @if (signalRGroup && device.deviceInformation) {
                  @let versionMismatch = (signalRGroup.appBuild && signalRGroup.appBuild != device.deviceInformation.appBuild) || (signalRGroup.appVersion && signalRGroup.appVersion != device.deviceInformation.appVersion);
                  <div class="flex justify-between gap-3 py-1">
                    <dt class="text-gray-500 shrink-0 inline-flex items-center gap-1" [class.text-red-600]="versionMismatch">
                      @if (versionMismatch) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" class="bi bi-exclamation-triangle text-red-600" viewBox="0 0 16 16">
                          <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                          <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                        </svg>
                      }
                      App-Version
                    </dt>
                    <dd class="text-gray-900 font-medium truncate text-right">
                      <span [class.text-red-600]="signalRGroup.appVersion && signalRGroup.appVersion != device.deviceInformation.appVersion">{{ device.deviceInformation.appVersion }}</span>
                      (<span [class.text-red-600]="signalRGroup.appBuild && signalRGroup.appBuild != device.deviceInformation.appBuild">{{ device.deviceInformation.appBuild }}</span>)
                    </dd>
                  </div>
                }

                <div class="flex justify-between gap-3 py-1">
                  <dt class="text-gray-500 shrink-0">Backlog</dt>
                  <dd class="text-gray-900 font-medium text-right inline-flex items-center gap-2 justify-end">
                    <span [class.text-red-600]="(device.deviceStats?.backlogCount ?? 0) > 0">{{ device.deviceStats?.backlogCount ?? 'N/A' }}</span>
                    @if (GetSignalRClient(device.id) && (device.deviceStats?.backlogCount ?? 0) > 0 && PermissionService.CheckPermission(PermissionService.Device_Information_RequestInformation())) {
                      <span class="text-xs font-medium">
                        (<span class="text-red-600 hover:text-red-800 cursor-pointer select-none" (click)="RequestInformation(GetSignalRClient(device.id)!.id, RequestedInformation.SerializedBacklog)">anzeigen</span>
                        | <span class="text-red-600 hover:text-red-800 cursor-pointer select-none" (click)="RequestInformation(GetSignalRClient(device.id)!.id, RequestedInformation.BacklogPushError)">senden</span>)
                      </span>
                    }
                  </dd>
                </div>

                <div class="flex justify-between gap-3 py-1">
                  <dt class="text-gray-500 shrink-0">Verbleibende IDs</dt>
                  <dd class="font-medium text-right" [class.text-red-600]="(device.deviceStats?.remainingOrderStatus ?? 20000) < 1000"
                      [class.text-gray-900]="(device.deviceStats?.remainingOrderStatus ?? 20000) >= 1000">
                    {{ device.deviceStats?.remainingOrderStatus ?? 'N/A' }}
                  </dd>
                </div>
              </dl>

              @if (device.deviceInformation) {
                <p class="text-xs text-gray-400 text-center">
                  Aktualisiert um {{ device.deviceInformation.modified | date : 'dd.MM.yyyy, HH:mm' }} Uhr
                </p>
              }
            </li>
          }
        </ul>
      }
    </div>
  </layout-page-scrollable>
</layout-page-container>
<app-json-viewer-popup [json]="sBacklog"></app-json-viewer-popup>
